import Languages from './Languages';

export default Languages;
